import style from "./Privacy.module.css";

export const Privacy = () => {
    return <div>Privacy</div>;
};
